enum ProgressTrackerStatus {
  CURRENT = 'current-stage',
  COMPLETED = 'completed',
  COMPLETED_GRAY = 'completed-gray',
  FUTURE = 'future',
}
enum ProgressTrackerDividerStatus {
  COMPLETED_DIVIDER = 'completed-divider',
  DASHED_DIVIDER = 'dashed-divider',
}
enum ProgressTrackerDividerAlignment {
  DEFAULT = 'default-divider-alignment',
  BOTTOM = 'bottom-divider-alignment',
}
enum ProgressTrackerDesign {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}
export { ProgressTrackerStatus, ProgressTrackerDesign, ProgressTrackerDividerStatus, ProgressTrackerDividerAlignment };
